import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const episodeApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/episodes/`,
      {params: params})
  },
  detail (episodeId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/episodes/${episodeId}/`,
      {params: params})
  },
  create (params) {
    // 创建新单集
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/episodes/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/episodes/`, querystring.stringify(params))
  },
  update (episodeId, params) {
    // 更新单集
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/episodes/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/episodes/${episodeId}/`, querystring.stringify(params))
  },
  private_cdn_exist (episodeId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/episodes/${episodeId}/private_cdn_exist/`,
      {params: params})
  },
  sold (episodeId) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/episodes/${episodeId}/sold/`,
    )
  }
}

export default episodeApi
